export interface INodeProps {
  id: string
  pid: string
  render?: string
  config?: any
  childrens?: any[]
}

function parse(content: {
  [key: string]: INodeProps | any
}): any {
  if (content === void 0) {
    return null;
  }

  return parseNode(content, 'root');
}

function parseNode(content: {
  [key: string]: INodeProps
}, id: string) {
  if (content[id] === void 0) {
    return null;
  }

  const {
    childrens,
    ...others
  } = content[id];

  let childNodes: any = [];
  if (childrens !== void 0 && childrens.length > 0) {
    childNodes = childrens.map((childId: string) => {
      if (content[childId] === void 0) {
        return null;
      }
      return parseNode(content, childId);
    }).filter(c => c !== null);

  }
  return {
    childrens: childNodes,
    ...others
  };
}

export default parse